// api.js

import axios from 'axios';

// 创建 Axios 实例
const api = axios.create({
  baseURL: '/', // 你的 API 地址
  timeout: 5000, // 请求超时时间（单位：毫秒）
});

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 在请求发送之前可以做一些操作，例如添加 token 等
    // config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token');
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  response => {
    // 在响应返回之后可以做一些操作，例如处理错误信息等
    const { code, data, message } = response.data || {};
    if (code === 0) {
      return data;
    }
    return Promise.reject(message);
  },
  error => {
    // 处理响应错误
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

export default api;
